// flagCode is the honeycomb flag file name, country is the flag's alt text (the language name is shown next to it).
export const languagesList = {
    en: {
        code: 'en',
        title: 'English',
        flagCode: 'gb',
        country: 'United Kingdom',
    },
    tr: {
        code: 'tr',
        title: 'Türkçe',
        flagCode: 'tr',
        country: 'Türkiye',
    },
    pt_BR: {
        code: 'pt_BR',
        title: 'Portuguese (BR)',
        flagCode: 'br',
        country: 'Brasil',
    },
    es_CL: {
        code: 'es_CL',
        title: 'Spanish (CL)',
        flagCode: 'cl',
        country: 'Chile',
    },
};

// The HTML lang attribute expects BCP 47 tags ("pt-BR"), the language keys use "pt_BR".
export const toLangTag = (code) => code.replace('_', '-');
